import styled from 'styled-components';

/**
 * The pair of figures above the MA Members table: welcome letters and membership badges issued.
 *
 * Two flat cards rather than a one-line sentence, because the two numbers are read against each
 * other — a letter count well ahead of the badge count is the sign that badge issuing is failing.
 */
export const Stats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Stat = styled.div`
  flex: 1 1 180px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.gray['100']};
  border: 1px solid ${({ theme }) => theme.colors.gray['200']};
`;

export const StatValue = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.tertiaries.darker};
`;

export const StatLabel = styled.div`
  margin-top: 2px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.colors.gray['500']};
`;
